// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__B9Kqk","navigationItem":"navigation_navigationItem__FlHdc","navigationLink":"navigation_navigationLink__PHh2_"};